export default class ShakaAdapter {
  checkExistsPlayer() {
    try {
      return this.checkExistsObjectOnPage(this._getTagFromPlayer());
    } catch (e) {
      console.error('Error checking player existence:', e);
      return !0;
    }
  }
  getBitrate() {
    var e = this.player.rawPlayer?.getStats(),
      t = null;
    return (
      void 0 !== e.streamBandwidth && (t = e.streamBandwidth),
      void 0 !== e.streamStats && (t = e.streamStats.videoBandwidth),
      t
    );
  }
  pauseListener(e) {
    (this.firePlayerLog('pauseListener', {}), this.firePause({}, 'pauseListener'));
  }
  bufferingListener(e) {
    (this.firePlayerLog('bufferingListener-' + e.buffering, {}),
      this.flags.isJoined
        ? !0 === e.buffering
          ? this.fireBufferBegin({}, !1, 'bufferingListenerEnabled')
          : !1 === e.buffering &&
            (this.flags.isSeeking
              ? (this.fireSeekEnd({}, 'bufferingListenerIsSeeking'), this.cancelBuffer())
              : this.fireBufferEnd({}, 'bufferingListenerDisabled'))
        : !0 === e.buffering
          ? this.fireBufferBegin({}, !1, 'bufferingListenerEnabled')
          : !1 === e.buffering && this.fireJoin({}, 'bufferingListenerNotJoined'));
  }
  getLatency() {
    var e = this.player.rawPlayer?.getStats().liveLatency;
    return e ? 1e3 * e : void 0;
  }
  getRendition() {
    var e = this._getActiveTrack();
    return e ? this.getNpawUtils().buildRenditionString(e.width, e.height, e.bandwidth) : null;
  }
  getPlayerVersion() {
    return this.player?.internalPlayerVersion || null;
  }
  playListener(e) {
    (this.firePlayerLog('playListener', {}), this._callStart('playListener'));
  }
  endedListener(e) {
    const t = this.getVideo().getAdsAdapter();
    let i = !1;
    (t && void 0 !== t.isDAI && (t.isDAI || (i = t.player.getCuePoints().includes(-1))),
      i ||
        (this.firePlayerLog('endedListener', {}),
        this.fireStop({}, 'endedListener'),
        (this.bytes = 0),
        (this.supportBytes = !1)));
  }
  getPlayrate() {
    return ('function' == typeof this.player?.getPlaybackRate && this.player.getPlaybackRate()) || 1;
  }
  timeupdateListener(e) {
    this.getPlayhead() !== this.initialPlayhead && 'number' == typeof this.initialPlayhead
      ? this._callStart('timeupdateListener')
      : (this.initialPlayhead = this.getPlayhead());
  }
  getPlayhead() {
    return this.player?.currentTime || null;
  }
  getDuration() {
    var e = this.tag || this._getTagFromPlayer();
    return e ? e.duration : null;
  }
  getFramesPerSecond() {
    var e = this._getActiveTrack();
    return e ? e.frameRate : null;
  }
  getThroughput() {
    return this.player.rawPlayer?.getStats().estimatedBandwidth;
  }
  getDroppedFrames() {
    return this.player.rawPlayer?.getStats().droppedFrames;
  }
  supportTotalBytes() {
    return this.supportBytes;
  }
  getTotalBytes() {
    return this.bytes;
  }
  _registerTag() {
    if (((this.tag = this.tag || this._getTagFromPlayer()), this.tag))
      for (var e in this.references) this.tag.addEventListener(e, this.references[e]);
    else setTimeout(this._registerTag.bind(this), 50);
  }
  getVersion() {
    return '7.0.5-shaka-jsclass';
  }
  seekedListener(e) {
    (this.firePlayerLog('seekedListener', {}),
      (this.isPlayerOnBuffering() && this.existPlayerBufferingMethod) ||
        (this.flags.isBuffering
          ? this.fireBufferEnd({}, 'seekedListener')
          : this.flags.isSeeking && this.fireSeekEnd({}, 'seekedListener')));
  }
  unregisterListeners() {
    ((this.bytes = 0), (this.supportBytes = !1), this.monitor && this.monitor.stop());
    var e = this.tag || this._getTagFromPlayer();
    if (e && this.references) {
      for (var t in this.references) e.removeEventListener(t, this.references[t]);
      delete this.references;
    }
    if (this.player.rawPlayer && this.referencesPlayer) {
      for (var i in this.referencesPlayer) this.player.rawPlayer?.removeEventListener(i, this.referencesPlayer[i]);
      delete this.referencesPlayer;
    }
  }
  getIsLive() {
    return !!this.player.rawPlayer?.isLive() || !this.getDuration();
  }
  _callStart(e) {
    (this.flags.isStarted || (this.fireStart({}, e), (this.initialPlayhead = this.getPlayhead())),
      this._initialPlayheadChanged() && this.fireJoin({}, e));
  }
  getTitle() {
    var e = this.tag || this._getTagFromPlayer();
    return e ? e.title : null;
  }
  networkResponseFilter(e, t) {
    try {
      if (e != shaka.net.NetworkingEngine.RequestType.SEGMENT) return;
      t && t.data && (this.bytes += t.data.byteLength);
    } catch (e) {}
  }
  registerListeners() {
    for (var e in ((this.bytes = 0),
    (this.supportBytes = !1),
    (this.existPlayerBufferingMethod =
      this.player.rawPlayer?.isBuffering && 'function' == typeof this.player.rawPlayer?.isBuffering),
    this.monitorPlayhead(!1, !0),
    (this.references = {
      play: this.playListener.bind(this),
      loadstart: this.autoplayListener.bind(this),
      pause: this.pauseListener.bind(this),
      playing: this.playingListener.bind(this),
      seeking: this.seekingListener.bind(this),
      seeked: this.seekedListener.bind(this),
      ended: this.endedListener.bind(this),
      timeupdate: this.timeupdateListener.bind(this),
    }),
    (this.referencesPlayer = {
      // error: this.errorListener.bind(this),
      buffering: this.bufferingListener.bind(this),
      loading: this.loadingListener.bind(this),
    }),
    (this.tag = null),
    this._registerTag(),
    this.referencesPlayer))
      // (this.player.subscribe('error', this.errorListener.bind(this)),
      this.player.rawPlayer?.addEventListener(e, this.referencesPlayer[e]);
    this.player.rawPlayer &&
      this.player.rawPlayer?.getNetworkingEngine &&
      'function' == typeof this.player.rawPlayer?.getNetworkingEngine &&
      this.player.rawPlayer?.getNetworkingEngine().registerResponseFilter &&
      'function' == typeof this.player.rawPlayer?.getNetworkingEngine().registerResponseFilter &&
      ((this.supportBytes = !0),
      this.player.rawPlayer?.getNetworkingEngine().registerResponseFilter(this.networkResponseFilter.bind(this)));
  }
  getResource() {
    var e = this.tag || this._getTagFromPlayer(),
      t = e ? e.currentSrc : null;
    return (
      this.player.rawPlayer?.getAssetUri && this.player.rawPlayer?.getAssetUri()
        ? (t = this.player.rawPlayer?.getAssetUri())
        : this.player.rawPlayer?.getManifestUri &&
          this.player.rawPlayer?.getManifestUri() &&
          (t = this.player.rawPlayer?.getManifestUri()),
      t
    );
  }
  _initialPlayheadChanged() {
    var e = !1;
    if (!this.flags.isJoined) {
      var t = this.getPlayhead(),
        i = this.initialPlayhead || 0,
        s = this.getVideo() ? this.getVideo().getIsLive() : this.getIsLive();
      ((0 !== i && s) || !s) && t > i ? (e = !0) : s && (this.initialPlayhead = t);
    }
    return e;
  }
  seekingListener(e) {
    (this.firePlayerLog('seekingListener', {}),
      this.fireSeekBegin({}, !1, 'seekingListener'),
      this.getVideo() && this.getVideo().getIsLive() && this.autoplayListener());
  }
  _getActiveTrack() {
    var e = null;
    if (this.player.rawPlayer?.getVariantTracks) {
      var t = this.player.rawPlayer?.getVariantTracks();
      for (var i in t) {
        var s = t[i];
        !s.active || ('video' !== s.type && 'variant' !== s.type) || (e = s);
      }
    } else if (this.player.rawPlayer?.getVideoTracks) {
      var r = this.player.rawPlayer?.getVideoTracks();
      for (var a in r) {
        var n = r[a];
        n.active && (e = n);
      }
    }
    return e;
  }
  getPlayerName() {
    return 'Shaka';
  }
  playingListener(e) {
    (this.firePlayerLog('playingListener', {}),
      this.fireResume({}, 'playingListener'),
      this._callStart('playingListener'),
      (this.isPlayerOnBuffering() && this.existPlayerBufferingMethod) || this.fireJoin({}, 'playingListener'));
  }
  isPlayerOnBuffering() {
    return !!this.existPlayerBufferingMethod && this.player.rawPlayer?.isBuffering();
  }
  loadingListener(e) {
    (this.firePlayerLog('loadingListener', {}),
      this.flags.isStarted && (this.fireStop({}, 'loadingListener'), (this.bytes = 0), (this.supportBytes = !1)));
  }
  autoplayListener(e) {
    this.firePlayerLog('autoplayListener', {});
    var t = this.tag || this._getTagFromPlayer();
    t && t.autoplay && this._callStart('autoplayListener');
  }
  errorListener(e) {
    this.firePlayerLog('errorListener', {});
    var t = e.detail && e.detail.code ? e.detail.code : e.code,
      i = e.detail && e.detail.message ? e.detail.message : 'unknown',
      s = e.detail && e.detail.category ? e.detail.category : e.category,
      r = e.detail && e.detail.severity ? e.detail.severity : e.severity;
    (s &&
      s < 10 &&
      s > 0 &&
      (i =
        {
          1: 'network',
          2: 'text',
          3: 'media',
          4: 'manifest',
          5: 'streaming',
          6: 'drm',
          7: 'player',
          8: 'cast',
          9: 'storage',
        }[s] || i),
      2 === r && -1 === [1002, 3016].indexOf(t)
        ? this.fireFatalError(t, i, void 0, void 0, 'errorListener')
        : this.fireError(t, i, void 0, void 0, 'errorListener'));
  }
  _getTagFromPlayer() {
    return this.player?.rawPlayer?.getMediaElement
      ? this.player.rawPlayer?.getMediaElement()
      : this.player.rawPlayer?.a;
  }
}
